import React from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';

const OPERATOR_OPTIONS = [
  { value: 'contains', label: 'Contains' },
  { value: 'eq', label: 'Equals' },
  { value: 'not_contains', label: 'Not contains' },
  { value: 'exists', label: 'Exists' },
  { value: 'not_exists', label: 'Not exists' },
];

const EmailSendContextFilters = ({
  filterRows,
  filterKeys,
  onUpdateRow,
  onRemoveRow,
  onAddRow,
  onApply,
  onClear,
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">Context Filters</Typography>
      {filterRows.map((row) => (
        <Stack key={row.id} direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems="center">
          <FormControl size="small" sx={{ minWidth: 240 }}>
            <InputLabel>Context Key</InputLabel>
            <Select
              label="Context Key"
              value={row.key}
              onChange={(event) => onUpdateRow(row.id, 'key', event.target.value)}
            >
              <MenuItem value="">
                <em>Select a key</em>
              </MenuItem>
              {filterKeys.map((entry) => (
                <MenuItem key={entry.key} value={entry.key}>
                  {entry.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Operator</InputLabel>
            <Select
              label="Operator"
              value={row.op}
              onChange={(event) => onUpdateRow(row.id, 'op', event.target.value)}
            >
              {OPERATOR_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            size="small"
            label="Value"
            value={row.value}
            onChange={(event) => onUpdateRow(row.id, 'value', event.target.value)}
            disabled={row.op === 'exists' || row.op === 'not_exists'}
            sx={{ flex: 1, minWidth: 200 }}
          />
          <Button variant="text" color="error" onClick={() => onRemoveRow(row.id)}>
            Remove
          </Button>
        </Stack>
      ))}
      <Stack direction="row" spacing={1}>
        <Button variant="outlined" onClick={onAddRow}>
          Add Filter
        </Button>
        <Button variant="contained" onClick={onApply}>
          Apply Filters
        </Button>
        <Button variant="text" onClick={onClear}>
          Clear
        </Button>
      </Stack>
    </Stack>
  );
};

export default EmailSendContextFilters;
